import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { scaleOnClickAnim } from "../../animations";
import { ReactComponent as SettingsSvg } from "../../../assets/menu.svg";
import currencies from "../../helpers/getCurrency";

const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    font-size: 26px;
    text-transform: uppercase;
  }
  span {
    /* color: #233b50;
    width: 100%;
    text-align: right;
    position: relative;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 12px;
    max-width: 150px; */
    svg {
      margin: 0px 4px;
      height: 28px;
      cursor: default;
      path {
        fill: #233b50;
      }
    }
  }
`;

export const BalanceContainer = styled.div`
    color: #233b50;
    font-size: 12px;
    max-width: 159px;
    width: 100%;
    text-align: right;
    position: relative;
    margin-left: 5px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
    flex-wrap: wrap;
    `
    
export const Balance = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
`
export const MenuIcon = styled.div`
  display: flex;
  pointer-events: ${(p) => (p.isDisabled ? "none" : "auto")};
  svg {
    max-width: 28px;
    max-height: 28px;
    cursor: pointer;
    animation: ${(p) => (p.menuBtn ? scaleOnClickAnim : null)};
    animation-duration: 0.333s;
    animation-fill-mode: forwards;
  }
`;
export default ({
  balance,
  handleAboveAnim,
  handleSetting,
  userInfo,
  floorFigure,
  audio,
}) => {
  const [menuBtnAnim, setmenuBtnAnim] = useState(false);
  const [localBalance, setLocalBalance] = useState(balance);
  const { curr, precision } = userInfo;

  useEffect(() => {
    balance === 0 ? setLocalBalance("0.00") : setLocalBalance(balance);
  }, [balance]);
  return (
    <HeaderDiv menuBtn={menuBtnAnim}>
      <p>mines</p>
      <BalanceContainer>
       <span>
        {currencies[curr]}
      </span>
      <Balance>{localBalance && floorFigure(localBalance, precision)}</Balance>
       </BalanceContainer>
      <MenuIcon menuBtn={menuBtnAnim} isDisabled={menuBtnAnim}>
        <SettingsSvg
          onAnimationEnd={() => {
            setmenuBtnAnim(false);
          }}
          onClick={() => {
            setmenuBtnAnim(true);
            audio();
            setTimeout(() => {
              handleSetting("settings");
              handleAboveAnim(true);
            }, 150);
          }}
        />
      </MenuIcon>
    </HeaderDiv>
  );
};
